import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fc-menu-divider',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'separator',
    class: 'block h-px shrink-0 -mx-4 bg-secondary-100',
  },
})
export class MenuDividerComponent {}
